import { render, staticRenderFns } from "./InputTextConfirmation.vue?vue&type=template&id=65dd0a3c&scoped=true"
import script from "./InputTextConfirmation.vue?vue&type=script&lang=js"
export * from "./InputTextConfirmation.vue?vue&type=script&lang=js"
import style0 from "./InputTextConfirmation.vue?vue&type=style&index=0&id=65dd0a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd0a3c",
  null
  
)

export default component.exports